/* eslint-disable react/display-name */
import { lazy } from 'react';
import { withErrorBoundary } from '@guildeducationinc/mfe-utils';
import { datadogRum } from '@datadog/browser-rum';

const CommunicationSettingsRemote = lazy(
  async () => await import(/* webpackChunkName: "remote/Nav" */ 'Comms/CommunicationSettings')
);

const CommunicationSettings = withErrorBoundary({
  component: CommunicationSettingsRemote,
  fallback: (error, componentStack) => {
    datadogRum.addError(error.message, {
      message: `[Critical] Communication Settings failed to load: ${error.message}`,
      stack: error.stack,
      errorName: error.name,
      componentInfo: componentStack,
    });
    return <></>;
  },
});

export default CommunicationSettings;
